import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-driver-location-modal',
	templateUrl: './driver-location-modal.component.html',
	styleUrls: ['./driver-location-modal.component.scss']
})
export class DriverLocationModalComponent {

	constructor(public dialogRef: MatDialogRef<DriverLocationModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any) {
	}

	close(response?) {
		this.dialogRef.close(response);
	}
}
